import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $ConfirmHeader = styled.div`
  margin-bottom: ${spacing('lg')};
`;

export const $ConfirmFooter = styled.footer`
  width: 100%;
  margin-top: ${spacing(12)};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: ${spacing('lg')};
`;
